import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "label" ]
  static classes = [ "hidden" ]
  static values = {
    changed: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    if (this.changedValue) {
      this.showChanged()
    }

    this.boundToggleTarget = this.toggleTarget.bind(this)
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)

    this.textInput.forEach(input => input.addEventListener("keyup", this.boundToggleTarget))
    this.numberInput.forEach(input => input.addEventListener("keyup", this.boundToggleTarget))
    this.radioInput.forEach(input => input.addEventListener("click", this.boundToggleTarget))
    this.checkboxInput.forEach(input => input.addEventListener("click", this.boundToggleTarget))
    this.rangeInput.forEach(input => input.addEventListener("change", this.boundToggleTarget))
    this.element.addEventListener("lexxy:change", this.boundToggleTarget)
    this.selectInput.on("select2:select", this.boundToggleTarget)
    this.form?.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  disconnect() {
    this.textInput.forEach(input => input.removeEventListener("keyup", this.boundToggleTarget))
    this.numberInput.forEach(input => input.removeEventListener("keyup", this.boundToggleTarget))
    this.radioInput.forEach(input => input.removeEventListener("click", this.boundToggleTarget))
    this.checkboxInput.forEach(input => input.removeEventListener("click", this.boundToggleTarget))
    this.rangeInput.forEach(input => input.removeEventListener("change", this.boundToggleTarget))
    this.element.removeEventListener("lexxy:change", this.boundToggleTarget)
    this.selectInput.off("select2:select", this.boundToggleTarget)
    this.form?.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  toggleTarget() {
    this.changedValue = true
    this.showChanged()
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.changedValue = false
      this.hideChanged()
    }
  }

  showChanged() {
    this.labelTarget.classList.remove(this.hiddenClass)
  }

  hideChanged() {
    this.labelTarget.classList.add(this.hiddenClass)
  }

  get textInput() {
    return this.element.querySelectorAll("input[type=text]")
  }

  get numberInput() {
    return this.element.querySelectorAll("input[type=number]")
  }

  get radioInput() {
    return this.element.querySelectorAll("input[type=radio]")
  }

  get checkboxInput() {
    return this.element.querySelectorAll("input[type=checkbox]")
  }

  get rangeInput() {
    return this.element.querySelectorAll("input[type=range]")
  }

  get selectInput() {
    return $(this.element).find("select")
  }

  get form() {
    return this.element.querySelector("form")
  }
}
